/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions*/
import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./LinkList.module.scss";
import { useHistory } from "react-router";
import classNames from "classnames/bind";
import { SOURCE } from "../navigationComponents/solutions/MenuOptionsHelpers";

interface Props {
  items: any[];
}

const LinkList: React.FC<Props> = ({ items }) => {
  const cx = classNames.bind(classes);
  const { t } = useTranslation();
  const history = useHistory();

  const handleOnClick = (link: any) => {
    if (link.path) {
      return history.push(link.path, { source: SOURCE });
    } else if (link.command) {
      link.command();
    }
  };

  return (
    <ul className={classes.linkList}>
      {items.map((item) => {
        return (
          <li key={item.label}>
            <a
              className={cx({ [classes.isSelected]: item.selected })}
              onClick={() => handleOnClick(item)}
            >
              <span>{t(item.label)}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default LinkList;
